// Fresh-eyes item 27 (Carla, 2026-10-12): what an in-app address that is no page shows. It used to
// show the Dashboard silently, as if the address had worked. The link is a real link to "/" (it works
// opened in a new tab too); a plain click goes through the app's own navigation (onHome).
import React from 'react';
import { PageLayout, PageHeader, EmptyState } from '../ui';

export default function NotFoundPage({ onHome }) {
  const goHome = (e) => {
    if (!onHome || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    onHome();
  };
  return (
    <PageLayout data-page="not-found" data-testid="page-not-found">
      <PageHeader title="Page not found" />
      <EmptyState icon="🧭" title="There is no page at this address"
        action={<a className="ui-btn ui-btn--create" href="/" onClick={goHome}>Go to your Dashboard</a>}>
        The link may be old or mistyped. Nothing has been changed.
      </EmptyState>
    </PageLayout>
  );
}
